import {postTypeConvert} from './utilities';
interface MainCardSwitcherProps {
  post: ICardData;
  type: string;
  subtype: string;
  homeCards?: boolean;
}
const MainCardSwitcher = ({
  type,
  subtype,
  post,
  homeCards,
}: MainCardSwitcherProps) => {
  return postTypeConvert[type](post, subtype, homeCards);
};

export default MainCardSwitcher;
